export const MAPPING_NOT_AVAILABLE_ERROR = 'mapping-not-available-error';
